import { Grid, Skeleton } from '@mui/material'

const CardSkelleton = () => {
  return (
    <Grid
      item
      xs={6}
    >
      <Skeleton
        variant='rounded'
        sx={{ width: '100%', minWidth: '33.75rem', height: '10.875rem' }}
      />
    </Grid>
  )
}

export default CardSkelleton
